import {
	Disclosure,
	DisclosureButton,
	DisclosurePanel,
	Menu,
	MenuButton,
	MenuItem,
	MenuItems,
} from "@headlessui/react";
import { BiSolidMessageRoundedDetail } from "react-icons/bi";
import {
	Bars3Icon,
	BellIcon,
	XMarkIcon,
	PlusIcon,
} from "@heroicons/react/24/outline";
import { LuUser2 } from "react-icons/lu";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { useAuth } from "../../Contexts/AuthContext/AuthContext";
import onelyk from "../../../src/Assets/onelyklogo.svg";
import ChangeStats from "../../Assets/changeStatus.svg";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { useSocket } from "../../Contexts/SocketContext/SocketContext";
import { baseUrl } from "../../Environments/environment";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import messageSound from "../../Assets/windows_sms.mp3";
import ChatListModal from "./Message/ChatListModal/ChatListModal";
import { toast } from "react-toastify";
import UpdatePropertyModal from "../PropertySetup/UpdateProperty/UpdateProperty";
import { LocalStorage } from "../../utils";
import { apiClient } from "../../api";
// import GlobalChatModal from "./Modal/GlobalChatModal";

const user = {
	name: "Tom Cook",
	email: "tom@example.com",
	imageUrl:
		"https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
};
const navigation = [
	{ name: "Home", href: "/dashboard", current: true },
	{ name: "Analytics", href: "/dashboard/analytics", current: false },
	// { name: "Settings", href: "/dashboard/configure/template", current: false },
	{ name: "Reviews", href: "/dashboard/reviews" },
];

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}
function requestNotificationPermission() {
	if ("Notification" in window) {
		Notification.requestPermission().then((permission) => {
			if (permission === "granted") {
				console.log("Notification permission granted.");
			} else {
				console.log("Notification permission denied.");
			}
		});
	} else {
		console.log("This browser does not support notifications.");
	}
}
const fetchChatList = async (baseUrl, selectedPropertyId, accessToken) => {
	const response = await apiClient.get(
		`${baseUrl}/chatList/${selectedPropertyId}`,
	);
	if (response.ok) {
		const newToken = response.headers.get("Authorization");
		if (newToken) {
			localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
		}
	}
	// console.log(response.data.result);
	return response.data.result;
};
function showNotification(title, message) {
	if (Notification.permission === "granted") {
		const notification = new Notification(title, {
			body: message, // Message body
		});

		notification.onclick = () => {
			window.focus();
		};
	}
}

const useReactQuerySubscription = (socket, baseUrl, selectedPropertyId, notificationSoundEnabled=true) => {
	const queryClient = useQueryClient();
	const messageAudio = new Audio(messageSound);
	useEffect(() => {
		requestNotificationPermission();
	}, []);

	useEffect(() => {
		socket.on("chatList:update", (update) => {
			queryClient.invalidateQueries({
				queryKey: ["chatList", selectedPropertyId],
			});

			if (update?.chatList?.unreadMessages > 0) {
				//messageAudio.play();
				showNotification(
					"New Message",
					"You have unread messages in your chat list.",
				);
			}
			if (typeof update === "object" && Object.keys(update).length === 0) {
				console.log("in 111",notificationSoundEnabled);
				if(notificationSoundEnabled){
					messageAudio.play();
				}
			}
		});

		socket.on("message:newMessage", (newMessage) => {
			queryClient.invalidateQueries({
				queryKey: ["chatList", selectedPropertyId],
			});

			if (newMessage?.message?.senderId !== selectedPropertyId) {
				queryClient.invalidateQueries([
					"messages",
					selectedPropertyId,
					newMessage?.message?.guestId,
				]);
				showNotification(
					"New Message",
					"You have unread messages in your chat list.",
				);
				console.log("in 222");
				if(notificationSoundEnabled){
					messageAudio.play();
				}
			}

			if (
				typeof newMessage === "object" &&
				Object.keys(newMessage).length === 0
			) {
				console.log("in 88");
				if(notificationSoundEnabled){
					messageAudio.play();
				}
			}
		});

		return () => {
			socket.off("chatList:update");
			socket.off("message:newMessage");
		};
	}, [socket, queryClient, baseUrl, selectedPropertyId, messageAudio]);
};

export default function Dashboard() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { logout } = useAuth();
	const {
		selectedPropertyId,
		setPropertyName,
		setPropertyTimezone,
		setPropertyChats,
	} = useProperty();
	const accessToken = LocalStorage.get("accessToken");
	const { socket } = useSocket();
	const navigate = useNavigate();
	const [verificationStatus, setVerificationStatus] = useState(null);
	const [loading, setLoading] = useState(true);
	const [isComplete, setIsComplete] = useState(false);
	const [isSubaccountCreated, setIsSubaccountCreated] = useState(false);
	const [rejectionInfo, setRejectionInfo] = useState(null);
	const [properties, setProperties] = useState([]);
	const [propertyNotificationSoundEnabled, setPropertyNotificationSoundEnabled] = useState(false);
	
	useEffect(() => {
		if (!selectedPropertyId) {
			navigate("/propertyhome");
			toast.warn("Select the property first!!");
		}
	}, [selectedPropertyId, navigate]);
	useEffect(() => {
		if (selectedPropertyId) {
			fetchPropertyData(selectedPropertyId);
		}
	}, [selectedPropertyId]);

	useEffect(() => {
		const fetchProperties = async () => {
			try {
				const propertyString = localStorage.getItem("properties");
				const propertiesList = JSON.parse(propertyString);
				setProperties(propertiesList || []);
			} catch (error) {
				console.error("Error fetching properties:", error);
			}
		};
		fetchProperties();
	}, []);

	const fetchPropertyData = async (propertyId) => {
		setLoading(true);
		try {
			const response = await apiClient.get(`${baseUrl}/property/${propertyId}`);

			if (response.status === 200) {
				const { property } = response.data.result.property;
				const { setting } = response.data.result;
				setPropertyName(property.name);
				setPropertyTimezone(setting.timezone);
				setPropertyNotificationSoundEnabled(setting.notificationSoundEnabled);
				localStorage.setItem("propertyNotificationSoundEnabled", setting.notificationSoundEnabled);
			
			}
		} catch (error) {
			const errorMessage =
				error.response?.data?.message || "Error fetching property data.";
			toast.error(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	useReactQuerySubscription(socket, baseUrl, selectedPropertyId,propertyNotificationSoundEnabled);

	const {
		data: chats = {},
		isLoading,
		error,
	} = useQuery({
		queryKey: ["chatList", selectedPropertyId],
		queryFn: () => fetchChatList(baseUrl, selectedPropertyId, accessToken),
		staleTime: 0,
		cacheTime: 0,
	});
	useEffect(() => {
		if (chats) {
			setPropertyChats(chats);
		}
	}, [chats, setPropertyChats]);

	const userNavigation = [
		{ name: "Property Details", href: "/dashboard/updateproperty" },
		// {
		//   name: "Update Property",
		//   href: "/dashboard/updateproperty",
		//   // onClick: () => setIsUpdateModalOpen(true),
		// },
		{ name: "Settings", href: "/dashboard/configure/template" },
		{
			name: "Sign out",
			href: "#",
			onClick: async () => {
				await logout();
				window.location.href = "/";
			},
		},
	];

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	useEffect(() => {
		const fetchTollFreeVerificationStatus = async () => {
			try {
				// console.log("morning", response.data.result.status);
			} catch (error) {
				setLoading(false);
				const errorMessage =
					error.response?.data?.message ||
					"Failed to fetch toll-free verification status. Please try again.";
				toast.error(errorMessage);
			}
		};
	}, [selectedPropertyId, accessToken]);
	useEffect(() => {
		const fetchIsTwilioSetup = async () => {
			if (!selectedPropertyId) return;
			setLoading(true);
			try {
				const response = await apiClient.get(
					`${baseUrl}/twilio/${selectedPropertyId}/isTwilioSetup`,
				);
				if (response.status === 200) {
					const {
						isSubaccountCreated: subCreated,
						isComplete: complete,
						verificationStatus: status,
						errorCode,
						rejectionReason,
						errorMessage,
					} = response.data.result;

					setIsSubaccountCreated(subCreated);
					setIsComplete(complete);
					setVerificationStatus(status ?? null);

					if (complete) {
						setRejectionInfo(null);
					} else if (
						status === "TWILIO_REJECTED" &&
						(errorCode != null || rejectionReason || errorMessage)
					) {
						setRejectionInfo({
							...(errorCode != null && { errorCode }),
							...(rejectionReason && { rejectionReason }),
							...(errorMessage && { errorMessage }),
						});
					} else {
						setRejectionInfo(null);
					}
				}
			} catch (error) {
				const errorMessage =
					error.response?.data?.message ||
					"Failed to fetch Twilio setup status. Please try again.";
				toast.error(errorMessage);
			} finally {
				setLoading(false);
			}
		};

		const handleResubmitTollFreeVerification = async () => {
			if (!selectedPropertyId) return;
			setLoading(true);
			try {
				await apiClient.post(
					`${baseUrl}/twilio/${selectedPropertyId}/resubmitTollFreeVerification`,
				);
				toast.success("Verification resubmitted. Twilio will review again.");
				await fetchIsTwilioSetup(); // refetch status so banner updates
			} catch (error) {
				const msg =
					error.response?.data?.message ||
					"Failed to resubmit verification. Please try again.";
				toast.error(msg);
			} finally {
				setLoading(false);
			}
		};

		fetchIsTwilioSetup();
	}, [selectedPropertyId]);
	const handleAddProperty = () => {
		navigate("/addProperty", {
			state: {
				isComplete: isComplete,
				propertyId: selectedPropertyId,
				isSubaccountCreated: isSubaccountCreated,
			},
		});
	};

	const handlePropertySwitch = async (propertyId) => {
		try {
			localStorage.setItem("selectedPropertyId", propertyId);
			window.location.reload();
		} catch (error) {
			const errorMessage =
				error.response?.data?.message || "Failed to switch property.";
			toast.error(errorMessage);
		}
	};
	const handleResubmitTollFreeVerification = async () => {
		// TODO: implement resubmission flow in backend and uncomment this function
		return;
	};

	// setVerificationStatus('TWILIO_APPROVED');
	return (
		<>
			<div className="min-h-full">
				{/* {loading && (
          <div className="bg-white p-1 rounded-md text-center my-">
            <span className="text-red-600 text-sm">
              Please wait we are checking twilio verification..
            </span>
          </div>
        )} */}
				<div>
					{!isComplete && !loading && (
						<div
							className={`border-l-4 p-4 flex justify-center items-center ${
								rejectionInfo
									? "bg-red-100 border-red-500 text-red-700"
									: "bg-yellow-100 border-yellow-500 text-yellow-700"
							}`}
							role="alert"
						>
							<div className="text-center">
								{!verificationStatus ||
								verificationStatus === "PENDING_OR_UNKNOWN" ? (
									// No number yet or status unknown
									<p>
										You have not completed the Phone number setup. Please click{" "}
										<button
											className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
											type="button"
											onClick={handleAddProperty}
										>
											here
										</button>{" "}
										to complete the phone number setup.
									</p>
								) : verificationStatus === "PENDING_REVIEW" ||
									verificationStatus === "IN_REVIEW" ? (
									// Under review
									<p>
										Your phone number is under review by Twilio. Approval
										typically takes up to 5 business days. You’ll be notified
										once it’s approved.
									</p>
								) : verificationStatus === "TWILIO_REJECTED" &&
									rejectionInfo ? (
									// Rejected
									<>
										<p className="font-medium mb-1">
											Phone number verification was rejected by Twilio.
										</p>
										{rejectionInfo.errorCode != null && (
											<p className="text-sm">
												Error code: {rejectionInfo.errorCode}
											</p>
										)}
										<p className="text-sm">
											{rejectionInfo.errorMessage ||
												rejectionInfo.rejectionReason}
										</p>
										<p className="mt-2 text-sm">
											Please fix the issues and{" "}
											<button
												type="button"
												onClick={handleResubmitTollFreeVerification}
												className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600 font-medium"
											>
												resubmit for approval
											</button>
											, or contact support.
										</p>
									</>
								) : (
									// Fallback (e.g. PENDING_OR_UNKNOWN with errorMessage from API)
									<p>
										You have not completed the Phone number setup. Please click{" "}
										<button
											className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
											type="button"
											onClick={handleAddProperty}
										>
											here
										</button>{" "}
										to complete the phone number setup.
										{rejectionInfo?.errorMessage && (
											<span className="block mt-1 text-sm">
												{rejectionInfo.errorMessage}
											</span>
										)}
									</p>
								)}
							</div>
						</div>
					)}
				</div>

				<div className="bg-indigo-600 pb-32">
					<Disclosure
						as="nav"
						className="border-b border-indigo-300 border-opacity-25 bg-indigo-600 lg:border-none"
					>
						<div className="mx-auto max-w-7xl px-2 sm:px-4 lg:px-8">
							<div className="relative flex h-16 items-center justify-between  lg:border-indigo-400 lg:border-opacity-25 mb-4">
								<div className="flex items-center px-2 lg:px-0">
									<div className="flex-shrink-0">
										<img
											alt="Your Company"
											src={onelyk}
											className="block h-13 w-13"
										/>
									</div>
									<div className="hidden lg:ml-10 lg:block">
										<div className="flex space-x-4">
											{navigation.map((item) => {
												const isActive = window.location.pathname === item.href;
												return (
													<a
														key={item.name}
														href={item.href}
														aria-current={isActive ? "page" : undefined}
														className={classNames(
															isActive
																? "bg-indigo-700 text-white"
																: "text-white hover:bg-indigo-500 hover:bg-opacity-75",
															"rounded-md px-3 py-2 text-sm font-medium",
														)}
													>
														{item.name}
													</a>
												);
											})}
										</div>
									</div>
								</div>
								{/* search */}
								{/* <div className="flex flex-1 justify-center px-2 lg:ml-6 lg:justify-end">
                  <div className="w-full max-w-lg lg:max-w-xs">
                    <label htmlFor="search" className="sr-only">
                      Search
                    </label>
                    <div className="relative text-gray-400 focus-within:text-gray-600">
                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassIcon
                          aria-hidden="true"
                          className="h-5 w-5"
                        />
                      </div>
                      <input
                        id="search"
                        name="search"
                        type="search"
                        placeholder="Search"
                        className="block w-full rounded-md border-0 bg-white py-1.5 pl-10 pr-3 text-gray-900 focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                </div> */}
								<div className="flex lg:hidden">
									{/* Mobile menu button */}
									<DisclosureButton className="group relative inline-flex items-center justify-center rounded-md bg-indigo-600 p-2 text-indigo-200 hover:bg-indigo-500 hover:bg-opacity-75 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600">
										<span className="absolute -inset-0.5" />
										<span className="sr-only">Open main menu</span>
										<Bars3Icon
											aria-hidden="true"
											className="block h-6 w-6 group-data-[open]:hidden"
										/>
										<XMarkIcon
											aria-hidden="true"
											className="hidden h-6 w-6 group-data-[open]:block"
										/>
									</DisclosureButton>
								</div>
								<div className="hidden lg:ml-4 lg:block">
									<div className="flex items-center">
										{/* <button
                      type="button"
                      className="relative flex-shrink-0 rounded-full bg-indigo-600 p-1 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600"
                    >
                      <span className="absolute -inset-1.5" />
                      <span className="sr-only">View notifications</span>
                      <BellIcon aria-hidden="true" className="h-6 w-6" />
                    </button> */}

										{/* Switch Property Dropdown */}
										<Menu as="div" className="relative mr-3 flex-shrink-0">
											<div>
												<MenuButton className="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 hover:bg-opacity-75 flex items-center space-x-2 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600">
													<img
														src={ChangeStats}
														alt="Switch Property"
														className="h-4 w-4 brightness-0 invert"
													/>
													<span>Switch Property</span>
												</MenuButton>
											</div>
											<MenuItems
												transition
												className="absolute right-0 z-10 mt-2 w-72 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in max-h-96 overflow-y-auto"
											>
												<MenuItem>
													{({ focus }) => (
														<button
															onClick={handleAddProperty}
															className={classNames(
																focus ? "bg-indigo-50" : "bg-indigo-50/50",
																"block w-full text-left px-4 py-3 text-sm text-indigo-600 font-semibold border-b border-gray-200 hover:bg-indigo-100 transition-colors",
															)}
														>
															<div className="flex items-center gap-2">
																<PlusIcon className="h-5 w-5 text-indigo-600" />
																<span>Add Property</span>
															</div>
														</button>
													)}
												</MenuItem>
												{properties.map((property) => (
													<MenuItem key={property._id}>
														{({ focus }) => (
															<button
																onClick={() =>
																	handlePropertySwitch(property._id)
																}
																className={classNames(
																	focus ? "bg-gray-100" : "",
																	selectedPropertyId === property._id
																		? "bg-indigo-50 text-indigo-600"
																		: "text-gray-700",
																	"block w-full text-left px-4 py-2 text-sm",
																)}
															>
																<div className="font-medium">
																	{property.name}
																</div>
																{(property.city || property.zipcode) && (
																	<div className="text-xs text-gray-500 mt-0.5">
																		{property.city}
																		{property.city && property.zipcode && ", "}
																		{property.zipcode}
																	</div>
																)}
															</button>
														)}
													</MenuItem>
												))}
											</MenuItems>
										</Menu>

										{/* Profile dropdown */}
										<Menu as="div" className="relative ml-3 flex-shrink-0">
											<div>
												<MenuButton className="relative flex rounded-full bg-indigo-600 text-sm text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600">
													<span className="absolute -inset-1.5" />
													<span className="sr-only">Open user menu</span>

													<div className="inline-flex items-center justify-center rounded-full bg-white p-2 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ml-auto">
														<LuUser2
															className="h-5 w-5"
															aria-hidden="true"
															color="#4f46e5"
														/>
													</div>
												</MenuButton>
											</div>
											<MenuItems
												transition
												className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
											>
												{userNavigation.map((item) => (
													<MenuItem key={item.name}>
														{({ focus }) => (
															<a
																href={item.href}
																onClick={item.onClick}
																className={classNames(
																	focus ? "bg-gray-100" : "",
																	"block px-4 py-2 text-sm text-gray-700",
																)}
															>
																{item.name}
															</a>
														)}
													</MenuItem>
												))}
											</MenuItems>
										</Menu>
									</div>
								</div>
							</div>
						</div>

						<DisclosurePanel className="lg:hidden">
							<div className="space-y-1 px-2 pb-3 pt-2">
								{navigation.map((item) => (
									<DisclosureButton
										key={item.name}
										as="a"
										href={item.href}
										aria-current={item.current ? "page" : undefined}
										className={classNames(
											item.current
												? "bg-indigo-700 text-white"
												: "text-white hover:bg-indigo-500 hover:bg-opacity-75",
											"block rounded-md px-3 py-2 text-base font-medium",
										)}
									>
										{item.name}
									</DisclosureButton>
								))}
							</div>
							<div className="border-t border-indigo-700 pb-3 pt-4">
								<div className="flex items-center px-5">
									<div className="flex-shrink-0">
										<img
											alt=""
											src={user.imageUrl}
											className="h-10 w-10 rounded-full"
										/>
									</div>
									<div className="ml-3">
										<div className="text-base font-medium text-white">
											{user.name}
										</div>
										<div className="text-sm font-medium text-indigo-300">
											{user.email}
										</div>
									</div>
									<button
										type="button"
										className="relative ml-auto flex-shrink-0 rounded-full bg-indigo-600 p-1 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600"
									>
										<span className="absolute -inset-1.5" />
										<span className="sr-only">View notifications</span>
										<BellIcon aria-hidden="true" className="h-6 w-6" />
									</button>
								</div>
								<div className="mt-3 space-y-1 px-2">
									{userNavigation.map((item) => (
										<DisclosureButton
											key={item.name}
											as="a"
											href={item.href}
											onClick={(e) => {
												if (item.onClick) {
													e.preventDefault();
													item.onClick();
												}
											}}
											className="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-indigo-500 hover:bg-opacity-75"
										>
											{item.name}
										</DisclosureButton>
									))}
								</div>
							</div>
						</DisclosurePanel>
					</Disclosure>
					{/* <header className="py-10">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold tracking-tight text-white">Dashboard</h1>
            </div>
          </header> */}
				</div>

				<main className="-mt-32">
					<div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8 ">
						{/* <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6"> */}
						<div className="rounded-lg bg-[#FFF] px-4 py-2 shadow sm:px-">
							{/* Your content */}

							{/* <Home/> */}
							<Outlet />
						</div>
					</div>
				</main>

				<button
					onClick={handleOpenModal}
					className="fixed bottom-6 right-6 bg-indigo-600 border-white border-2 text-white rounded-full p-3 shadow-lg hover:bg-indigo-500 transition"
				>
					<BiSolidMessageRoundedDetail className="h-8 w-8" />

					{chats.totalUnreadMessages > 0 && (
						<span className="absolute -top-0 -right-0 bg-yellow-500 text-white text-xs font-semibold rounded-full h-5 w-5 flex items-center justify-center z-100">
							{chats.totalUnreadMessages}
						</span>
					)}
				</button>

				{isModalOpen && (
					<ChatListModal onClose={handleCloseModal} chats={chats} />
				)}

				{/* {isUpdateModalOpen && (
          <UpdatePropertyModal
            selectedPropertyId={selectedPropertyId}
            accessToken={accessToken}
            onClose={() => setIsUpdateModalOpen(false)}
          />
        )} */}
			</div>
		</>
	);
}
